import React from 'react';

function NoStoresMessageTemplate ({ modelAttributes }) {

	const { regionName, zipCode } = modelAttributes;

	return (
		<>
			{zipCode && (
				<>
					{"Sorry, we don't have any stores near "}
					{zipCode}
				</>
			)}

			{regionName && (
				<>
					{"Sorry, we don't have any stores in "}
					{regionName}
				</>
			)}
		</>
	);

}

export default NoStoresMessageTemplate;
